import { useQueryClient } from "@tanstack/react-query";
import { usePostHog } from "posthog-js/react";

import { useKeycloak } from "@/auth/KeycloakAuthState.ts";
import { Queries } from "@/queries/Queries.ts";

export const useInitPostHog = () => {
  const queryClient = useQueryClient();
  Queries.user.useFeatureFlags.prefetch(queryClient, {});
  const impersonating = useKeycloak(state => state.impersonating);
  const me = Queries.user.useMe({});
  const posthog = usePostHog();

  if (me.userType === "patient") {
    posthog?.opt_out_capturing();
  } else if (!impersonating) {
    posthog?.identify(me.id, {
      email: me.email,
    });
  }
};
